import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
const API = window.location.origin + '/api';
const VerifyAddress = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading'|'success'|'error'>('loading');
  const token = searchParams.get('token');
  useEffect(() => {
    if (!token) return setStatus('error');
    axios.get(`${API}/profile/verify-address?token=${token}`).then(() => setStatus('success')).catch(() => setStatus('error'));
  }, [token]);
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 w-full max-w-md text-center">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-black text-2xl" style={{ backgroundColor: '#B8860B' }}>X</div>
          <p className="font-bold text-gray-900 text-lg">BULLIONX</p>
        </div>
        {status === 'loading' && <p className="text-gray-500">Verifying...</p>}
        {status === 'success' && (<>
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4"><span className="text-green-600 text-2xl">✓</span></div>
          <h3 className="text-lg font-bold text-gray-900 mb-2">Address Verified!</h3>
          <p className="text-gray-500 text-sm mb-6">Your shipping address has been verified successfully.</p>
          <Link to="/home" className="w-full py-2.5 rounded-lg font-semibold text-sm text-white inline-block" style={{ backgroundColor: '#1a1a2e' }}>Go to Dashboard</Link>
        </>)}
        {status === 'error' && (<>
          <h3 className="text-lg font-bold text-gray-900 mb-2">Invalid link</h3>
          <p className="text-gray-500 text-sm mb-6">This verification link is invalid or has expired.</p>
          <Link to="/login" className="text-sm" style={{ color: '#B8860B' }}>Back to login</Link>
        </>)}
      </div>
    </div>
  );
};
export default VerifyAddress;
